import { Component, EventEmitter, Output, inject } from '@angular/core';
import { UserAuthFacade } from '@state/user-auth';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss'],
  standalone: false,
})
export class CompanyLogoComponent {
  private readonly userAuthFacade = inject(UserAuthFacade);

  public branding$ = this.userAuthFacade.branding$;

  @Output() logoClicked: EventEmitter<void> = new EventEmitter();
}
